import { AxiosResponse } from 'axios';
import { SearchResult } from '../../../Model/Dto/SearchResult';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';

import * as ApiUrls from './ApiUrl.GeneratedCertificateRegistry';
import { GeneratedCertificateRegistry } from '../../../Model/Dto/GeneratedCertificateRegistry';

export const GeneratedCertificateRegistryService = {
    Search : (input : GeneratedCertificateRegistry.SearchRequest) : Promise<AxiosResponse<SearchResult<GeneratedCertificateRegistry.SearchResult>>> => 
        axiosCoreInstance.post(ApiUrls.Search,input),
};
